var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co input",class:{
        'has-icon': _vm.icon,
        readonly: _vm.readonly,
    }},[(_vm.label)?_c('CoLabel',{staticClass:"d-block",attrs:{"text":_vm.label}}):_vm._e(),_c('div',{staticClass:"d-flex"},[(_vm.icon)?_c('CoIcon',{staticClass:"icon align-self-center",attrs:{"name":_vm.icon}}):_vm._e(),_c('input',{ref:"coInputElem",staticClass:"align-self-center flex-grow-1",class:{
                'has-icon': _vm.icon,
            },attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }